module.exports = __webpack_public_path__ + "static/media/9.e069369f.jpg";